var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-image",
    _vm._b(
      { attrs: { src: _vm.themedPath, loading: "lazy" } },
      "base-image",
      { ..._vm.$attrs, ..._vm.$props },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }